import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_LEADS = createRequestTypes('lms/FETCH_LEADS');
export const UPDATE_LEAD = createRequestTypes('lms/UPDATE_LEAD');
export const RESET_LEADS = 'lms/RESET_LEADS';
export const FETCH_FILTERS_CONFIG = createRequestTypes('lms/FETCH_FILTERS_CONFIG');
export const FETCH_LEAD_CONFIG = createRequestTypes('lms/FETCH_LEAD_CONFIG');
export const FETCH_LEAD_INFO = createRequestTypes('lms/FETCH_LEAD_INFO');
export const LEAD_EXOTEL = createRequestTypes('lms/LEAD_EXOTEL');
export const UPDATE_HOT_LEAD = createRequestTypes('lms/UPDATE_HOT_LEAD');

export const fetchLeads = {
  request: (params) => createAction(FETCH_LEADS[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_LEADS[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_LEADS[FAILURE], { response }),
  resetLeads: (payload) => createAction(RESET_LEADS, { payload }),
};

export const updateLead = {
  request: (params) => createAction(UPDATE_LEAD[REQUEST], { params }),
  success: (response, params) => createAction(UPDATE_LEAD[SUCCESS], { response, ...params }),
  failure: (response) => createAction(UPDATE_LEAD[FAILURE], { response }),
};

export const fetchFiltersConfig = {
  request: (params) => createAction(FETCH_FILTERS_CONFIG[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_FILTERS_CONFIG[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_FILTERS_CONFIG[FAILURE], { response }),
};

export const fetchLeadConfig = {
  request: () => createAction(FETCH_LEAD_CONFIG[REQUEST]),
  success: (response, params) => createAction(FETCH_LEAD_CONFIG[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_LEAD_CONFIG[FAILURE], { response }),
};

export const fetchLeadInfo = {
  request: (params) => createAction(FETCH_LEAD_INFO[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_LEAD_INFO[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_LEAD_INFO[FAILURE], { response }),
};

export const leadExotel = {
  request: (params) => createAction(LEAD_EXOTEL[REQUEST], { params }),
  success: (response, params) => createAction(LEAD_EXOTEL[SUCCESS], { response, params }),
  failure: (response) => createAction(LEAD_EXOTEL[FAILURE], { response }),
};

export const updateHotLead = {
  request: (params) => createAction(UPDATE_HOT_LEAD[REQUEST], { params }),
  success: (response, params) => createAction(UPDATE_HOT_LEAD[SUCCESS], { response, ...params }),
  failure: (response) => createAction(UPDATE_HOT_LEAD[FAILURE], { response }),
};
